import { Component, OnInit } from '@angular/core';
import { HeaderData } from 'src/app/_models/header-data';
import { CommonService } from 'src/app/_services/common.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {

  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;
  private loading: boolean = false;
  private faqs = [];
  private faqBody = [];
  
  //private killServicesOnDestroy = [];

  constructor(private sanitizer: DomSanitizer, private commonService: CommonService) { }

  ngOnInit() {
    /* Setting Headers Starts */
    this.headerData = new HeaderData();
    this.setHeaderData();
    /* Setting Headers Ended */
    this.fetchFAQs();
  }

  setHeaderData(){
    this.headerData.pageTitle = "FAQs";
    this.commonService.header = this.headerData;
    this.headerData.detailMenuParentClass = "text-right";
    this.headerData.detailMenuClass = "float-right";
    this.headerData.detailMenu = [
      {label: "Need help? Contact support", labelClass: "faq-label", description: "<a class='faq-anchor' href='mailto:support@coactionspecialty.com'>support@coactionspecialty.com</a>", descClass: "faq-desc text-right", needFilter: false}];  
  }

  fetchFAQs(){
    this.loading = true;
    let faqsSubscription = this.commonService.fetchFAQs().subscribe((faqs:any) => {
      this.loading = false;
      faqs.forEach(faq => {
        if(faq.body.includes('vsrc="')){
          faq.body = faq.body.replace('vsrc=','<iframe width="250" height="150" src=');
        }
        if(faq.body.includes('=vsrc')){
          faq.body = faq.body.replace('=vsrc',' frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
        }
        faq.body = this.sanitizer.bypassSecurityTrustHtml(faq.body);
      });
      this.faqs = faqs;
    },error=>{
      this.loading = false;
    });

    this.commonService.runningServices.push(faqsSubscription);
  }
}